export { JSONAPISerializer as default } from '@warp-drive/legacy/serializer/json-api';
